export enum AUTOLOCK_ERROR {
  OCPP = 'OCPP',
  MODEL_NOT_COMPATIBLE = 'MODEL_NOT_COMPATIBLE'
}

export interface ChargerAutoLockCompatible {
  isCompatible: boolean
  reason?: AUTOLOCK_ERROR
}
